import { AllStandardsList, allTab } from "./AllStandardsList.component";

export { AllStandardsList, allTab };
